module.exports = __webpack_public_path__ + "img/fig37.495dfcd8.jpg";